import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from "react-router";
import './index.css'
import AdminHoursBlocker from './AdminHoursBlocker.jsx'
import Home from './Home.jsx'
import Menu from './Menu.jsx'
import Payment from './Payment.js'
import PaymentReturn from './PaymentReturn.js'
import PrivacyPolicy from './PrivacyPolicy.js';
import TermsOfUse from './Terms.js';
const onsiteLogo = 'https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/chris-onsite-logo-gold.png'

createRoot(document.getElementById('root')).render(
  <StrictMode>
      <BrowserRouter>
        <Suspense 
            fallback={
              <div style={{ textAlign: 'center', marginTop: '50px', height: "100vh", width: "100vw" }}>
                <div style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                  <img src={onsiteLogo} alt="Chris Onsite Logo" />
                </div>
              </div>
            }
        >
          <Routes>
              <Route index element={<Home />} />
              <Route 
                path="/menu" 
                element={<Menu />} />
              <Route 
                path="/call" 
                element={<Home zoomTo="call-chris" />} />
              <Route 
                path="/text" 
                element={<Home zoomTo="text-chris" />} />
              <Route 
                path="/schedule" 
                element={<Home zoomTo="schedule" />} />
              <Route 
                path="/services" 
                element={<Home zoomTo="serviceBtnContainer" />} />
              <Route 
                path="/connect" 
                element={<Home zoomTo="view-instagram" />} />
              <Route 
                path="/privacy" 
                element={<PrivacyPolicy />} />
              <Route 
                path="/terms" 
                element={<TermsOfUse />} />
              <Route 
                path="/checkout/:serviceType" 
                element={<Payment />} />
              <Route 
                path="/payment-return" 
                element={<PaymentReturn />} />
              <Route 
                path="/zero-receipt" 
                element={<PaymentReturn zeroReceipt={true} />} />
              <Route 
                path="/admin" 
                element={<AdminHoursBlocker />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
  </StrictMode>,
)
